import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesService {
  private hasUnsavedChanges = new BehaviorSubject<boolean>(false);
  setUnsavedChanges(status: boolean) {
    this.hasUnsavedChanges.next(status);
  }

  getUnsavedChanges$() {
    return this.hasUnsavedChanges.asObservable();
  }

  get hasUnsaved() {
    return this.hasUnsavedChanges.value;
  }
}
